import { http } from "@/http/axios.js";
import { dateFormat } from "@/utils/index.js";
import { exportData } from "@/utils/export.js";

// 获取售后订单列表（共用接口）
export function getAfterSaleOrderListAPI(params) {
  return http({
    url: "/admin/afterSaleOrder/page",
    method: "get",
    params,
  });
}

// 导出（共用接口）
export function exportAfterSaleOrderAPI(data, fileName) {
  exportData(
    "/api/admin/afterSaleOrder/export",
    data,
    fileName || `果冻租售后订单${dateFormat()}.xlsx`,
  );
}

